// extracted by mini-css-extract-plugin
module.exports = {"root":"PageSpinner_root__1JUqE","fullPage":"PageSpinner_fullPage__LV4Zc"};